module.exports = __webpack_public_path__ + "img/terms_jp.9adc44f.jpg";